function cov_13i89ydul2() {
  var path = "/codebuild/output/src315236701/src/src/common/store/featureFlags.ts";
  var hash = "5133a58f19b97c37e182402beaa964f3833c76e5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src315236701/src/src/common/store/featureFlags.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 21
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 36
        },
        end: {
          line: 27,
          column: 2
        }
      },
      "2": {
        start: {
          line: 10,
          column: 29
        },
        end: {
          line: 10,
          column: 92
        }
      },
      "3": {
        start: {
          line: 10,
          column: 76
        },
        end: {
          line: 10,
          column: 89
        }
      },
      "4": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 11,
          column: 47
        }
      },
      "5": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 24,
          column: 9
        }
      },
      "6": {
        start: {
          line: 13,
          column: 12
        },
        end: {
          line: 15,
          column: 13
        }
      },
      "7": {
        start: {
          line: 14,
          column: 16
        },
        end: {
          line: 14,
          column: 34
        }
      },
      "8": {
        start: {
          line: 16,
          column: 12
        },
        end: {
          line: 23,
          column: 15
        }
      },
      "9": {
        start: {
          line: 17,
          column: 16
        },
        end: {
          line: 22,
          column: 17
        }
      },
      "10": {
        start: {
          line: 18,
          column: 20
        },
        end: {
          line: 18,
          column: 53
        }
      },
      "11": {
        start: {
          line: 21,
          column: 20
        },
        end: {
          line: 21,
          column: 78
        }
      },
      "12": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 9,
            column: 5
          }
        },
        loc: {
          start: {
            line: 9,
            column: 12
          },
          end: {
            line: 26,
            column: 5
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 65
          },
          end: {
            line: 10,
            column: 66
          }
        },
        loc: {
          start: {
            line: 10,
            column: 76
          },
          end: {
            line: 10,
            column: 89
          }
        },
        line: 10
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 16,
            column: 27
          },
          end: {
            line: 16,
            column: 28
          }
        },
        loc: {
          start: {
            line: 16,
            column: 44
          },
          end: {
            line: 23,
            column: 13
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 24,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 24,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 13,
            column: 12
          },
          end: {
            line: 15,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 13,
            column: 12
          },
          end: {
            line: 15,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 13
      },
      "2": {
        loc: {
          start: {
            line: 17,
            column: 16
          },
          end: {
            line: 22,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 16
          },
          end: {
            line: 22,
            column: 17
          }
        }, {
          start: {
            line: 20,
            column: 21
          },
          end: {
            line: 22,
            column: 17
          }
        }],
        line: 17
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/codebuild/output/src315236701/src/src/common/store/featureFlags.ts",
      sourceRoot: "",
      sources: ["/codebuild/output/src315236701/src/node_modules/vue-cli-plugin-quasar/lib/loader.js.transform-quasar-imports.js!/codebuild/output/src315236701/src/src/common/store/featureFlags.ts"],
      names: [],
      mappings: "AAAA,OAAO,EAAE,WAAW,EAAE,MAAM,OAAO,CAAC;AAEpC,MAAM,YAAY,GAAG;IACnB,oCAAoC;IACpC,gBAAgB;IAChB,cAAc;IACd,OAAO;CAC6B,CAAC;AAMvC,MAAM,CAAC,MAAM,oBAAoB,GAAG,WAAW,CAAC,cAAc,EAAE;IAC9D,KAAK;QACH,MAAM,YAAY,GAAG,MAAM,CAAC,WAAW,CAAC,YAAY,CAAC,GAAG,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,CAAC,CAAC,IAAI,EAAE,KAAK,CAAC,CAAC,CAAC,CAAiB,CAAC;QAErG,IAAI,MAAM,GAAG,QAAQ,EAAE,EAAE,KAAK,EAAE,OAAO,CAAC;QACxC,IAAI,MAAM,EAAE;YACV,IAAI,CAAC,KAAK,CAAC,OAAO,CAAC,MAAM,CAAC,EAAE;gBAC1B,MAAM,GAAG,CAAC,MAAM,CAAC,CAAC;aACnB;YACD,MAAM,CAAC,OAAO,CAAC,CAAC,WAAW,EAAE,EAAE;gBAC7B,IAAI,YAAY,CAAC,OAAO,CAAC,WAA0B,CAAC,IAAI,CAAC,EAAE;oBACzD,YAAY,CAAC,WAAW,CAAC,GAAG,IAAI,CAAC;iBAClC;qBAAM;oBACL,OAAO,CAAC,IAAI,CAAC,8BAA8B,WAAW,EAAE,CAAC,CAAC;iBAC3D;YACH,CAAC,CAAC,CAAC;SACJ;QAED,OAAO,YAAY,CAAC;IACtB,CAAC;CACF,CAAC,CAAC;AAEH,eAAe,oBAAoB,CAAC",
      sourcesContent: ["import { defineStore } from 'pinia';\n\nconst featureNames = [\n  // Add/remove feature flag IDs here:\n  // 'animations',\n  'responsivity',\n  'games',\n] as const satisfies readonly string[];\n\ntype FeatureName = typeof featureNames[number]\n\ntype FeatureFlags = Record<FeatureName, boolean>\n\nexport const useFeatureFlagsStore = defineStore('featureFlags', {\n  state(): FeatureFlags {\n    const featureFlags = Object.fromEntries(featureNames.map((name) => ([name, false]))) as FeatureFlags;\n\n    let params = useRoute()?.query?.feature;\n    if (params) {\n      if (!Array.isArray(params)) {\n        params = [params];\n      }\n      params.forEach((featureName) => {\n        if (featureNames.indexOf(featureName as FeatureName) >= 0) {\n          featureFlags[featureName] = true;\n        } else {\n          console.warn(`Invalid feature flag name: ${featureName}`);\n        }\n      });\n    }\n\n    return featureFlags;\n  },\n});\n\nexport default useFeatureFlagsStore;\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5133a58f19b97c37e182402beaa964f3833c76e5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_13i89ydul2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_13i89ydul2();
import { defineStore } from 'pinia';
const featureNames = (cov_13i89ydul2().s[0]++, [
// Add/remove feature flag IDs here:
// 'animations',
'responsivity', 'games']);
export const useFeatureFlagsStore = (cov_13i89ydul2().s[1]++, defineStore('featureFlags', {
  state() {
    cov_13i89ydul2().f[0]++;
    const featureFlags = (cov_13i89ydul2().s[2]++, Object.fromEntries(featureNames.map(name => {
      cov_13i89ydul2().f[1]++;
      cov_13i89ydul2().s[3]++;
      return [name, false];
    })));
    let params = (cov_13i89ydul2().s[4]++, useRoute()?.query?.feature);
    cov_13i89ydul2().s[5]++;
    if (params) {
      cov_13i89ydul2().b[0][0]++;
      cov_13i89ydul2().s[6]++;
      if (!Array.isArray(params)) {
        cov_13i89ydul2().b[1][0]++;
        cov_13i89ydul2().s[7]++;
        params = [params];
      } else {
        cov_13i89ydul2().b[1][1]++;
      }
      cov_13i89ydul2().s[8]++;
      params.forEach(featureName => {
        cov_13i89ydul2().f[2]++;
        cov_13i89ydul2().s[9]++;
        if (featureNames.indexOf(featureName) >= 0) {
          cov_13i89ydul2().b[2][0]++;
          cov_13i89ydul2().s[10]++;
          featureFlags[featureName] = true;
        } else {
          cov_13i89ydul2().b[2][1]++;
          cov_13i89ydul2().s[11]++;
          console.warn(`Invalid feature flag name: ${featureName}`);
        }
      });
    } else {
      cov_13i89ydul2().b[0][1]++;
    }
    cov_13i89ydul2().s[12]++;
    return featureFlags;
  }
}));
export default useFeatureFlagsStore;